import Header from "../components/header";
import Footer from "../components/footer";
import { Link, useParams } from "react-router-dom";
import { useRef } from "react";

const Landing = () => {
    const {duid} = useParams();
    const btn = useRef();
    const downloadfile = () => {
        btn.current.innerHTML = "downloading, please wait...";
        fetch('https://api.voicecoach.net/ck/'+duid).then(res => {if (!res.ok) {
            window.location.href = "/";
        } else {
            window.location.href = "https://api.voicecoach.net/ck/dl/"+duid;
            btn.current.innerHTML = "Downloaded... redirecting";
            setTimeout(() => window.location.href = '/', 1000);
        }});
    }
    return <>
<Header />
<main className="container">
<section className="my-5">
        <div className="row">
        <div className="col-12 text-center my-3">Your one-time download link is ready.</div>
        <div className="col-lg-4 col-12 mx-auto">
            <button className="btn btn-primary w-100" ref={btn} onClick={downloadfile}>Click here to Download your eBook</button>
        </div>
    </div>
    <div className="row">
        <div className="col-8 mx-auto my-3">
<p>Need more than eBook?
</p><p>
Our <b>in-person classes</b> are designed with a hands-on approach, combining theoretical knowledge with practical exercises and assignments. You will have the opportunity to engage with industry professionals, connect with fellow podcasters, and receive personalized feedback on your progress. With our interactive platform, you can ask questions, participate in discussions, and gain insights from real-world experiences, ensuring a dynamic and engaging learning experience.
</p>
<p>
<b>Key topics covered in our classes include:</b>
</p>
<ul>
<li>Finding your podcasting niche: Discovering the ideal subject matter and target audience for your podcast, ensuring a focused and engaging show.</li>
<li>Planning and scripting: Learning the art of structuring your episodes, crafting compelling narratives, and engaging your listeners through effective storytelling.</li>
<li>Recording and production techniques: Mastering the technical aspects of podcasting, including audio recording, editing, and enhancing sound quality.</li>
<li>Podcast hosting and distribution: Understanding the various podcast hosting platforms and strategies for distributing your episodes to reach a wider audience.</li>
<li>Monetization and growth strategies: Exploring different methods to monetize your podcast, such as sponsorships, advertising, merchandise, and developing strategies to grow your listener base.</li>
</ul>
<p>
By completing our "<b>Learn How to Podcast</b>" classes, you will be equipped with the necessary skills and knowledge to confidently launch your podcast and showcase your unique voice to the world. Whether your goal is to entertain, educate, or inspire, our service empowers you to make a meaningful impact through the power of podcasting.
</p>
<p>Unlock the potential of your voice! <Link to="/booking">Click here to Book your sessions.</Link></p>
</div>
    </div>
</section>
</main>
<Footer />
    </>
}

export default Landing;